module.exports = __webpack_public_path__ + "img/banner-mastercard-mcafee-mobile.489d9f19.jpg";